import script from "./create-meeting-button.vue?vue&type=script&lang=js"
export * from "./create-meeting-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__